(function($){

	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: false,
			// prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points="20.77 70 8.15 35.01 20.93 0 13.02 0 0 35 13.02 70 20.77 70"/></svg></button>',
			// nextArrow: '<button class="slick-arrow slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.93 70"><polygon points=".16 0 12.78 34.99 0 70 7.91 70 20.93 35 7.91 0 .16 0"/></svg></button>',
			dots: false,
			fade: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false,
			lazyLoad: 'ondemand',
		});
	};

	var heroVideo = function() {

		$('[data-action="hero-popup-play"]').on('click', function(e) {
			e.preventDefault();

			var heroVideoModal = document.getElementById('hero-video-modal');
			var heroVideoModalObj = $('#hero-video-modal');

			$.magnificPopup.open({
				mainClass: 'hero-popup',
				items: {
					src: '#hero-video-modal-container',
					type: 'inline',
				},
				callbacks: {
					open: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.play();
						}
					},
					close: function() {
						if(heroVideoModalObj.length){
							heroVideoModal.pause();
							heroVideoModal.currentTime = 0;
						}
					},
				}
			}, 0);
			
		});
		
		$('[data-action="hero-popup-embed"]').magnificPopup({
			type: 'iframe',
			// mainClass: 'hero-popup'
		});

	};


	var scrollAnim = function(){
		var win = $(window);
		var items = $('.scroll-animate-item');
		if (!items.length) return;

		var itemScrollCheck = function(){
			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * 0.8) + winTop;

			items.each(function(i, el){
				var item = $(el);
				var itemTop = item.offset().top;
				if (itemTop <= scrollTriggerPos) item.addClass('vis');
				else item.removeClass('vis');
			});
		};

		var ticking = false;
		var onScroll = function(){
			if (!ticking) {
				window.requestAnimationFrame(function(){
					itemScrollCheck();
					ticking = false;
				});
				ticking = true;
			}
		};

		itemScrollCheck();
		win.on('scroll resize', onScroll);
		win.on('load', itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			// window.scrollTo(0,0);

			$( 'body' ).removeClass( 'nav-open' );
			
			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 501;

				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 1000);


				}, waitTime);
			}
		}

		$('.scroll-to-anchor a, a[href^="#"]').on('click', function(e){

			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 0;
					
					if(!$('body').hasClass('scrolled')){
						waitTime = 501;
						$('body').addClass('scrolled');
					}

					setTimeout(function(){
						var anchorPosition = hashTarget.offset().top;
						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						$("html, body").animate({scrollTop: finalPosition}, 1000);

						$( 'body' ).removeClass( 'nav-open' );

					}, waitTime);
				}
			}
		});
	};

	var blockGallery = function() {
		$('.wp-block-gallery').magnificPopup({
			delegate: 'a',
			type: 'image',
			gallery: {
				enabled: true
			}
		});
	};

	var serviceCards = function() {
		// Remove HTML [hidden] so CSS max-height can animate instead
		$('.service-expand').removeAttr('hidden');

		$('.service-card-inner').on('click', function(e) {
			// Let clicks on the learn-more link pass through as normal links
			if ($(e.target).closest('.service-learn-more').length) { return; }

			var $inner  = $(this);
			var $card   = $inner.closest('.service-card');
			var $toggle = $inner.find('.service-toggle');
			var $expand = $inner.find('.service-expand');

			var open = $card.toggleClass('open').hasClass('open');
			$toggle.attr('aria-expanded', open ? 'true' : 'false');

			if ($expand.length) {
				// Use measured scrollHeight so animation matches exact content height
				$expand[0].style.maxHeight = open ? ($expand[0].scrollHeight + 'px') : '0';
			}
		});
	};

	var faqs = function() {
		$('[data-action="faq"]').each(function(){
			var $li = $(this);
			$li.find('.question').on('click', function(e) {
				e.preventDefault();
				var open = $li.toggleClass('open').hasClass('open');
				$(this).attr('aria-expanded', open ? 'true' : 'false');
			});
		});
	};

	// var scrolledClass = function() {
	// 	var body = $('body');
	// 	var update = function(){
	// 		if (window.scrollY > 30) {
	// 			body.addClass('scrolled');
	// 		} else {
	// 			body.removeClass('scrolled');
	// 		}
	// 	};
	// 	update();
	// 	if (typeof optimizedScroll !== 'undefined') {
	// 		optimizedScroll.add(update);
	// 	} else {
	// 		$(window).on('scroll', update);
	// 	}
	// };

	// var diagramPie = function() {
	// 	var $pieContainer = $('.home-diagram-image');
	// 	var $pie = $('.diagram-pie');
	// 	if (!$pie.length) return;

	// 	// Maps 45° segments (0 = top, clockwise) to slice numbers
	// 	// Segment 0 = 0–45° → slice 8, segment 1 = 45–90° → slice 6, etc.
	// 	var sliceMap = [8, 6, 4, 2, 7, 5, 3, 1];

	// 	var closeAll = function() {
	// 		$pieContainer.find('.hover').removeClass('active');
	// 	};

	// 	// Highlight the slice icon the cursor is currently over
	// 	$pie.on('mousemove', function(e) {
	// 		var rect = this.getBoundingClientRect();
	// 		var cx   = rect.left + rect.width  / 2;
	// 		var cy   = rect.top  + rect.height / 2;
	// 		var x    = e.clientX - cx;
	// 		var y    = e.clientY - cy;

	// 		$pie.find('.slice').removeClass('hovered');

	// 		if (Math.sqrt(x * x + y * y) < rect.width / 2 * 0.28) return;

	// 		var angle   = (Math.atan2(x, -y) * (180 / Math.PI) + 360) % 360;
	// 		var segment = Math.floor(angle / 45);
	// 		var num     = sliceMap[segment];
	// 		$pie.find('.pie-slice-' + num).addClass('hovered');
	// 	});

	// 	$pie.on('mouseleave', function() {
	// 		$pie.find('.slice').removeClass('hovered');
	// 	});

	// 	// Click on a slice: open its panel (or close if already open)
	// 	$pie.on('click', function(e) {
	// 		// Let close-button clicks be handled by their own handler below
	// 		if ($(e.target).closest('.hover-close').length) return;
	// 		// Let link clicks pass through normally
	// 		if ($(e.target).closest('.link').length) return;

	// 		var rect = this.getBoundingClientRect();
	// 		var cx   = rect.left + rect.width  / 2;
	// 		var cy   = rect.top  + rect.height / 2;
	// 		var x    = e.clientX - cx;
	// 		var y    = e.clientY - cy;

	// 		// Click in the centre logo zone — close any open panel
	// 		if (Math.sqrt(x * x + y * y) < rect.width / 2 * 0.28) {
	// 			closeAll();
	// 			return;
	// 		}

	// 		// Angle from 12 o'clock, clockwise, 0–360
	// 		var angle   = (Math.atan2(x, -y) * (180 / Math.PI) + 360) % 360;
	// 		var segment = Math.floor(angle / 45); // 0–7
	// 		var num     = sliceMap[segment];

	// 		var $target = $pieContainer.find('.pie-hover-' + num);

	// 		// Toggle: clicking the same slice again closes the panel
	// 		if ($target.hasClass('active')) {
	// 			// closeAll();
	// 			// e.stopPropagation();
	// 		} else {
	// 			closeAll();
	// 			$target.addClass('active');
	// 		}
	// 	});

	// 	// Close button inside a panel
	// 	// $pie.on('click', '.hover-close', function() {
	// 	// 	$(this).closest('.hover').removeClass('active');
	// 	// });
	// 	$('.pie-hover-panels .hover').on('click', function(e) {
	// 		e.stopPropagation();
	// 	});
	// 	$('.hover-close').on('click', function(e) {
	// 		e.stopPropagation();
	// 		closeAll();
	// 	});
	// };

	var diagram2 = function() {
		var $diagram2Container = $('.home-diagram-2');
 
		$('[data-action="diagram2-point"]').on('click', function(e) {
			
			$('.diagram2-point').not(this).removeClass('active');

			var $target = $($(this).data('target'));


			// Toggle: clicking the same slice again closes the panel
			if ($target.hasClass('active')) {
				closeAll();
				// e.stopPropagation();
			} else {
				closeAll();
				$target.addClass('active');
				$(this).addClass('active');
			}
		});
		
		var closeAll = function() {
			$diagram2Container.find('.hover').removeClass('active');
			$('.diagram2-point').removeClass('active');
		};

		$('.pie-hover-panels .hover').on('click', function(e) {
			e.stopPropagation();
		});
		$('.hover-close').on('click', function(e) {
			e.stopPropagation();
			closeAll();
		});
	};


	var footerNav = function() {
		var $toggle = $('.footer-nav-toggle');
		var $wrap   = $('.footer-nav-wrap');

		if (!$toggle.length) return;

		$toggle.on('click', function() {
			var open = $wrap.toggleClass('open').hasClass('open');
			$toggle.attr('aria-expanded', open ? 'true' : 'false');
		});
	};


	var aboutVideo = function() {
		var $links = $('.home-about-video .home-about-video-link');
		if (!$links.length) return;

		$links.on('click keydown', function(e) {
			if (e.type === 'keydown' && e.which !== 13 && e.which !== 32) return;
			e.preventDefault();
			var $overlay = $(this);
			var $video   = $overlay.closest('.home-about-video').find('video.home-about-video-embed');
			if ($video.length) {
				$overlay.fadeOut(200);
				$video[0].play();
			}
		});
	};

	// var platformSlider = function() {
	// 	$('.platform-slider').slick({
	// 		arrows: true,
	// 		prevArrow: '<button class="platform-arrow platform-arrow-prev" type="button" aria-label="Previous slide"><i class="far fa-chevron-left" aria-hidden="true"></i></button>',
	// 		nextArrow: '<button class="platform-arrow platform-arrow-next" type="button" aria-label="Next slide"><i class="far fa-chevron-right" aria-hidden="true"></i></button>',
	// 		dots: false,
	// 		speed: 1000,
	// 		autoplay: false,
	// 		// autoplaySpeed: 4000,
	// 		pauseOnHover: false,
	// 		// lazyLoad: 'ondemand',
	// 	});
	// };


	$(document).ready(function(){
		homeHeroSlider();
		heroVideo();
		scrollAnim();
		scrollToAnchor();
		blockGallery();
		serviceCards();
		faqs();
		// scrolledClass();
		// diagramPie();
		diagram2();
		footerNav();
		aboutVideo();
		// platformSlider();
	});

	var contactMap = function() {
		var el = document.getElementById('gmap');
		if (!el || !el.getAttribute('data-lat')) return;
		if (typeof google === 'undefined' || !google.maps) return;

		var lat   = parseFloat(el.getAttribute('data-lat'));
		var lng   = parseFloat(el.getAttribute('data-lng'));
		var addr  = el.getAttribute('data-address') || '';
		var title = el.getAttribute('data-title') || '';

		var center = { lat: lat, lng: lng };
		var map = new google.maps.Map(el, {
			center: center,
			zoom: 15,
			mapTypeControl: false,
			scrollwheel: false,
			draggable: false,
			disableDoubleClickZoom: true,
		});
		var marker = new google.maps.Marker({ position: center, map: map });

		var directionsUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(addr);
		var iwContent =
			'<div style="font-family:\'DM Sans\',sans-serif;padding:4px 2px;min-width:160px;">' +
				(title ? '<p style="margin:0 0 5px;font-weight:700;font-size:14px;color:#0f1f3d;">' + title + '</p>' : '') +
				(addr  ? '<p style="margin:0 0 10px;font-size:13px;color:#3d4f6f;line-height:1.5;">' + addr.replace(/\n/g, '<br>') + '</p>' : '') +
				(addr  ? '<a href="' + directionsUrl + '" target="_blank" style="font-size:12px;font-weight:600;color:#0080ff;text-decoration:none;">Get Directions &rarr;</a>' : '') +
			'</div>';

		var infoWindow = new google.maps.InfoWindow({ content: iwContent });
		infoWindow.open(map, marker);
		marker.addListener('click', function() { infoWindow.open(map, marker); });
	};

    window.addEventListener('load', function() {
        var videoContainer = $('.hero-video-container');
        videoContainer.addClass('vis');
		contactMap();
    }, false);

})(jQuery);

/* Lazy load bg images https://web.dev/lazy-loading-images/ */
// document.addEventListener("DOMContentLoaded", function() {
//   var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

//   if ("IntersectionObserver" in window) {
//     let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(entry) {
//         if (entry.isIntersecting) {
//           entry.target.classList.add("visible");
//           lazyBackgroundObserver.unobserve(entry.target);
//         }
//       });
//     });

//     lazyBackgrounds.forEach(function(lazyBackground) {
//       lazyBackgroundObserver.observe(lazyBackground);
//     });
//   }
// });